import { postApi, getApi, uploadApi } from "@/util/http.js";

/**搜索社区首页
 * @param {String} classification  分类
 * @param {String} content 搜索内容
 * @param {Number} current  当前页数
 * @param {Number} limit   每页条数
 */
export const searchCommByPage = (data) =>
  postApi("/admin/community/path/searchCommByPage", data);

/**获取社区投稿信息
 *@param {String} id 文件id
 */
export const findFileInfo = (params) =>
  getApi("/admin/community/path/findFileInfo", params);

/** 获取卡盒类型-文件列表
 *  @param {String} id 社区id
 *  @param {String} current 当前页数
 *  @param {String} limit 每页条数
 *  @param {String} type 分类 1：最外层卡盒，2：内部卡盒
 */
export const findCommCardByPage = (params) =>
  getApi("/admin/community/path/findCommCardByPage", params);


/** 获取视频点播的播放地址
 * resourceId: 资源id
 * "uploadLocation": 1,       上传位置（0：中台， 1：社区）
 */
export const resourceGetPlayUrl = (resourceId) =>
  getApi("/admin/resource/getPlayUrl", { resourceId, uploadLocation: 1 });

/** 获取文件类型-内容列表(分页)
 *  @param {String} id 社区id
 *  @param {String} current 当前页数
 *  @param {String} limit 每页条数
 */
export const findAllContentByPage = (params) =>
  getApi("/admin/community/path/findAllContentByPage", params);

/** 获取文件类型-所有内容
 *  @param {String} id 社区id
 */
export const findAllContent = (params) =>
  getApi("/admin/community/path/findAllContent", params);

/**点赞
 * @param {String} id 文件id
 */
export const addThanks = (params) =>
  getApi("/admin/community/path/thanks", params);

/**关注/取消关注用户
 * @param {String} userId  用户id
 */
export const followUser = (data) =>
  postApi("/admin/community/path/follow/unfollow", data);

/**添加学习、创建副本
 * @param {String} id 文件id
 */
export const addLearning = (params) =>
  getApi("/admin/community/path/receive/commFile", params);

/** 判断用户投稿文件是否合格
 *  @param {String} id 社区id
 *  @param {String} type 0卡盒，1文件夹
 */
export const checkUserFile = (params) =>
  getApi("/admin/community/path/file/isQualified", params);

/** 新增OR修改内容评论
 *  @param {String} cassetteId 内容id
 *  @param {String} commentContent 评论内容
 *  @param {Number} score 评分
 */
export const insertOrUpdate = (data) =>
  postApi("/admin/communitycassettecomment/insertOrUpdate", data);

/** 查询评论列表
 *  @param {String} cassetteId 内容id
 *  @param {String} page  当前页数
 *  @param {String} limit 每页条数
 */
export const findPageList = (params) =>
  getApi("/admin/communitycassettecomment/findPageList", params);

/** 删除评论
 *  @param {String} id 评论id
 */
export const deleteById = (data) =>
  postApi("/admin/communitycassettecomment/deleteById", data);

/** 回复评论
 *  @param {String} id 回复id
 *  @param {String} commentId 评论id
 *  @param {String} remarkContent 评论内容
 */
export const replyComment = (data) =>
  postApi("/admin/communitycassettecomment/remark/insertOrUpdate", data);

/** 评论点赞
 *  @param {String} ccid 文件id
 *  @param {String} commentId 评论id
 *  @param {String} deleted 1点赞，-1取消点赞
 */
export const addCommentThanks = (data) =>
  postApi("/admin/communitycassettecomment/thumb/insertOrUpdate", data);
